/* eslint-disable no-unused-vars */
import { Typography, Modal, Box, Zoom, Paper } from "@mui/material";
import PropTypes from "prop-types";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import CloseDialogIcon from "../icons/purposed/CloseDialogIcon";
import MyDivider from "./MyDivider";
import { lazy } from "react";
import LazyLoader from "./Progress/LazyLoader";
const MuokkaustilaButton = lazy(() =>
  import("src/components/buttons/purposed/MuokkaustilaButton/MuokkaustilaButton")
);

const styles = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
};
export default function MyModal({
  title = "",
  isOpen = false,
  closeButtonText = "SULJE",
  closeButtonIcon = null,
  dataIsChanged = false,
  dialogProps = { maxWidth: "md" },
  helpId,
  fullHeight = false,
  minHeight = "default",
  enableCancel = false,
  isLoading = false,
  showMuokkausTilaButton = false,
  saveButtonText = "TALLENNA",
  buttonSize = "medium",
  showCloseButton = true,
  showCloseIcon = true,
  enableCloseButton = true,
  ...props
}) {
  const handleClose = () => props.onClose();
  const handleCancel = () => (props.onCancel !== undefined ? props.onCancel() : props.onClose());

  // remove maxWidth from dialogProps
  const { maxWidth, ...rest } = dialogProps;

  return (
    <Modal
      sx={styles.modal}
      open={isOpen}
      slotProps={{
        backdrop: {
          timeout: 1000,
        },
      }}
      {...rest}>
      <Zoom in={isOpen}>
        <Box
          className="dialog"
          sx={{
            "& .MuiTextField-root": { m: 1 },
          }}>
          <Paper
            elevation={3}
            sx={{
              minHeight: fullHeight ? "99vh" : minHeight,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}>
            <div style={{ flexGrow: 1, height: "100%" }}>
              <div
                className="spaceBetween"
                style={{
                  flexGrow: 1,
                  paddingTop: "8px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  height: "100%",
                }}>
                <Typography color="primary" variant="h6" component="span">
                  {title || "Otsikko puuttuu"}
                </Typography>
                <div style={{ display: "flex" }}>
                  {helpId && <HelperIcon helpId={helpId} alignRight={false} />}
                  <LazyLoader>
                    {showMuokkausTilaButton && <MuokkaustilaButton hideHelp />}
                  </LazyLoader>
                  {showCloseIcon && (
                    <CloseDialogIcon
                      onClick={handleCancel}
                      dataIsChanged={dataIsChanged}
                      dontAskId="closeDialogIcon"
                    />
                  )}
                </div>
              </div>
              <MyDivider />
              <div style={{ flexGrow: 1, height: "100%" }}>{props.children}</div>
            </div>
            <div className="stepModal" style={{ width: "100%" }}>
              {enableCancel ? (
                <>
                  <StepButtons
                    closeText={closeButtonText}
                    rightButtonText={saveButtonText}
                    closeIcon={closeButtonIcon}
                    onSaveKlik={handleClose}
                    onCancelKlik={handleCancel}
                    disabled={!enableCloseButton}
                    isLoading={props.isLoading}
                    size={buttonSize}
                  />
                </>
              ) : (
                <>
                  {showCloseButton && (
                    <StepButtons
                      closeText={closeButtonText}
                      closeIcon={closeButtonIcon}
                      onCloseKlik={handleClose}
                      disabled={!enableCloseButton}
                      isLoading={props.isLoading}
                      size={buttonSize}
                    />
                  )}
                </>
              )}
            </div>
          </Paper>
        </Box>
      </Zoom>
    </Modal>
  );
}

MyModal.propTypes = {
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  isOpen: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  closeButtonText: PropTypes.string,
  enableCloseButton: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  onCancel: PropTypes.func,
  helpId: PropTypes.string,
  dataIsChanged: PropTypes.bool,
  dialogProps: PropTypes.object,
  closeButtonIcon: PropTypes.node,
  fullHeight: PropTypes.bool,
  minHeight: PropTypes.string,
  enableCancel: PropTypes.bool,
  isLoading: PropTypes.bool,
  showMuokkausTilaButton: PropTypes.bool,
  saveButtonText: PropTypes.string,
  buttonSize: PropTypes.string,
};

/**
 * 
 * USAGE
 * 
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <MyModal
      title={"Otsikko puuttuu"}
      isOpen={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      showCloseButton={true} 
      enableCloseButton={true} // optional, close button is disabled if false 
      showCloseIcon={true} // optional, close icon in top right corner is hidden if false
      closeButtonText={"SULJE"} // optional
      closeButtonIcon={<CloseIcon />} // optional
       // optional
      helpId={"helpId"} // optional
      fullHeight={false} // optional
      dataIsChanged={false} // optional
      dialogProps={{
        fullWidth={true},
        maxWidth={"md"} // "xs" | "sm" | "md" | "lg" | "xl" | false
        fullScreen={false} // optional
      }} // optional
    >
       Modalcontents
    </MyModal>
  );
 */
